var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"newsDetail"},[_c('div',{staticClass:"main"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"time"},[_vm._v("发布日期："+_vm._s(_vm.add_time))]),_c('div',{staticClass:"content margin-top-30",domProps:{"innerHTML":_vm._s(_vm.content)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }